import { render, staticRenderFns } from "./ViStaffLeaveRequest.vue?vue&type=template&id=5eef7cf3&scoped=true"
import script from "./ViStaffLeaveRequest.vue?vue&type=script&lang=js"
export * from "./ViStaffLeaveRequest.vue?vue&type=script&lang=js"
import style0 from "./ViStaffLeaveRequest.vue?vue&type=style&index=0&id=5eef7cf3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5eef7cf3",
  null
  
)

export default component.exports